export default __webpack_public_path__ + "static/media/layer5.48ed792e.svg";